// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3pNBA","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2SA7i","obliqueLine":"membershipbadge_obliqueLine__1kWYD"};